/**
 * efeedback2.js
 *
 * Version    : 1.0.0
 * Release    : 1-1-2016
 * License    : CHECK24
 */
(function() {
    $(document).ready(function() {
        const oFeedback = $('.mod24eFeedback2');
        const iFeedbackId = oFeedback.data('id');
        let iStars = oFeedback.data('stars');
        let iPage = 0;
        const iMax = oFeedback.data('max');
        const oCommentTemplate = $('.box24Comments li', oFeedback).first();
        let bCheckActiveTag = false;
        const oCommentArray = [];

        // Needs the Rotator Plugin for rotating the Hot feedbacks...
        if ($.isFunction($().c24Rotator)) {
            $('.box24HotFeedbacks li').c24Rotator();
        }

        // Does the filtering
        $('.js24Filter', oFeedback).on('click', function() {
            if (!$(this).hasClass('selected')) {
                $('.js24Filter', oFeedback).removeClass('selected');
                $(this).addClass('selected');
                iStars = $(this).data('stars');
                iPage = 0;
                if (bCheckActiveTag) {
                    refreshTypeComments();
                } else {
                    refreshComments();
                }

                if (window.c24LpIsMobile) {
                    $('html, body').animate({
                        scrollTop: $(oFeedback).offset().top,
                    }, 200);
                }
            }
        });

        // Does the paginating
        $(oFeedback).on('click', '.js24Page', function() {
            if (!$(this).hasClass('c24Selected')) {
                iPage = $(this).data('page');

                if (bCheckActiveTag) {
                    refreshTypeComments();
                } else {
                    refreshComments();
                }

                if (window.c24LpIsMobile) {
                    $('html, body').animate({
                        scrollTop: $('.box24Bottom', oFeedback).offset().top,
                    }, 200);
                }
            }
        });

        /**
     * refresh the Comments
     */
        function refreshComments(page, stars) {
            if (page !== undefined) iPage = page;
            if (stars !== undefined) iStars = stars;
            oFeedback.append('<div class="box24Loading" style="display: none;"></div>');
            $('.box24Loading', oFeedback).stop().fadeTo(100, 0.4);

            $.getJSON(window.c24LpRoot + 'api/?k=24&a=efeedback&q=' + iFeedbackId + '&stars=' + iStars + '&page=' + iPage + '&max=' + iMax, function(json) {
                if (json.status == 200) {
                    const iLast = json.data.comments.length;

                    // Does the comments
                    if (iLast > 0) {
                        let sHtml = '';
                        for (let i = 0; i < iLast; i++) {
                            const oComment = json.data.comments[i];
                            const o = $('<li>').append(oCommentTemplate);
                            $('.inl24Stars', o).html('<span class="c24StarsS"><span class="c24StarsS c24StarsFilled" style="width:' + calcStarWidth(oComment.stars, 69) + 'px"></span></span>');
                            $('.inl24Name', o).html(cleanString(oComment.name));
                            $('.inl24Type', o).html(oComment.type == 1 ? 'Feedback nach Abschluss' : 'Feedback nach 2 Jahren');
                            $('.inl24Date', o).html(oComment.date);
                            $('.inl24Text', o).html(cleanString(oComment.comment));
                            if (oComment.details && oComment.details.length) {
                                $('.inl24Product', o).html('Produkt : ' + cleanString(oComment.details[0].detail));
                            } else {
                                $('.inl24Product', o).html('');
                            }
                            sHtml += o.html();
                        }
                        if (sHtml) {
                            if (iStars === 0) {
                                $('.box24Bottom .inl24Header', oFeedback).text('Die neuesten Kundenbewertungen mit Kommentar');
                            } else {
                                $('.box24Bottom .inl24Header', oFeedback).text(iStars + ' Stern' + (iStars != 1 ? 'e' : '') + ' Kundenbewertungen mit Kommentar');
                            }
                            $('.box24Comments', oFeedback).html(sHtml);
                            $('.box24Comments li', oFeedback).last().addClass('c24Last');
                        }
                    } else {
                        $('.box24Comments', oFeedback).html('<li class="inl24None">Wir konnten leider f&uuml;r Ihre Auswahl keine Kundenbewertungen mit Kommentar finden.</li>');
                    }

                    // Does the paginating
                    if (json.data.filter !== undefined) {
                        let sHtml = '';
                        if (json.data.filter.totalpages > 0) {
                            for (let i = 0; i <= json.data.filter.totalpages && i < 5; i++) {
                                sHtml += '<li class="js24Page ' + (i == iPage ? ' c24Selected' : '') + '" data-page="' + i + '">' + (i + 1) + '</li>';
                            }
                            $('.box24Paginating', oFeedback).show();
                        } else {
                            $('.box24Paginating', oFeedback).hide();
                        }
                        $('.box24Paginating', oFeedback).html(sHtml);
                    }

                    $('.box24Loading', oFeedback).stop().fadeOut(50, function() {
                        $(this).remove();
                    });
                } else {
                    $('.box24Loading', oFeedback).stop().fadeOut(50, function() {
                        $(this).remove();
                    });
                }
            });
        }


        $('.tag', oFeedback).on('click', function () {

            const jSelf = $(this);
            const defaultTag = $('.tag.default', oFeedback);

            if (($('.tag', oFeedback).hasClass('active') && !jSelf.hasClass('active')) || defaultTag.hasClass('default')) {
                $('.tag.active', oFeedback).removeClass('active');
                jSelf.addClass('active');
                const type = jSelf.data();

                if (type.type === 'total') {
                    bCheckActiveTag = false;
                } else {
                    bCheckActiveTag = true;
                }
                refreshTypes(type.type);
                $('.box24Loading', oFeedback).stop().fadeIn(100,function refreshTypes() {
                    $(this).remove();
                });

            }
            if (defaultTag.hasClass('default')) {
                defaultTag.removeClass('default');
            }

        });

        function refreshTypes(typeName) {
            const oCommentArray = [];

            let type = 0;

            switch (typeName) {
                case 'service':
                    type = 1;
                    break;
                case 'loss':
                    type = 2;
                    break;
                case 'application':
                    type = 3;
                    break;
                default:
                    type = 0;
                    break;
            }

            $.getJSON(window.c24LpRoot + 'api/?k=24&a=efeedback&q=' + iFeedbackId , function(json) {
                if (json.status === 200) {
                    const iLast = json.data.comments.length;
                    const scoreInt = json.data.stars[type].score;
                    const score = (json.data.stars[type].score).toString().replace('.', ',');
                    const total = json.data.stars[type].total;
                    const mostVotes = json.data.stars[type].most_votes;
                    const ratings = json.data.ratings[type][0];

                    $('.star_rate').html('<strong> ' + score + '</strong>');

                    $('.c24StarsM.c24StarsFilled').html('<span class="c24StarsM"> <span class ="c24StarsM c24StarsFilled" title=" ' + score + ' von 5 Sternen" > </span></span>');
                    $('.c24StarsM.c24StarsFilled').css(
                        'width' , calcStarWidth(scoreInt, 93),
                    );
                    $('.type_total_customer').html('<span class="type_total_customer">' + total + '</span>');

                    for (let i = 5; i > 0; i--) {
                        $('.li.js24Filter.filter' + i).html('<span>' + i + ' Stern' + (i != 1 ? 'e' : '') + ' </span>');
                        const adjust = calcAdjust(ratings[mostVotes], total, 90);
                        const progressBar = $('.c24ProgressBarFilled.filter' + i);

                        progressBar[0].style.width = calcPercentage(ratings[i], total, adjust) + '%';
                        $('.c24Count.filter' + i).html('<li>' + ratings[i] + '</li>');
                    }

                    if (type === 0) {
                        refreshComments();
                    } else {

                        if (iLast > 0) {

                            for (let i = 0; i < iLast; i++) {
                                const oComment = json.data.comments[i];
                                if ((oComment.comment_type === type) && (type !== 0)) {
                                    oCommentArray.push(oComment);
                                }
                            }
                        }

                        refreshTypeComments();
                    }
                }
            });

        }

        function refreshTypeComments() {

            let iLast = oCommentArray.length;
            const maxNumberPage = iMax;

            if (iLast > 0) {
                let oTempCommentArray = oCommentArray;

                if (iStars > 0) {
                    oTempCommentArray = starElector();
                    iLast = oTempCommentArray.length;
                }

                let sHtml = '';

                if (iLast > maxNumberPage) {
                    const maxTotalPage = Math.ceil((iLast / maxNumberPage));
                    for (let i = 0; i < maxTotalPage && i < 5 ; i++) {
                        sHtml += '<li class="js24Page ' + (i == iPage ? ' c24Selected' : '') + '" data-page="' + i + '">' + (i + 1) + '</li>';
                    }
                    $('.box24Paginating', oFeedback).show();
                } else {
                    $('.box24Paginating', oFeedback).hide();
                }
                $('.box24Paginating', oFeedback).html(sHtml);

                sHtml = '';

                let beginNum;
                let toNum;

                if (iLast < maxNumberPage) {
                    beginNum = 0;
                    toNum = iLast;
                } else {
                    beginNum = iPage * maxNumberPage;
                    toNum = beginNum + maxNumberPage;
                    if (toNum > iLast) {
                        toNum = beginNum + (iLast - beginNum);
                    }
                }


                if (iLast > 0) {
                    for (let i = beginNum; i < toNum; i++) {
                        const oComment = oTempCommentArray[i];
                        const o = $('<li>').append(oCommentTemplate);

                        $('.inl24Stars', o).html('<span class="c24StarsS"><span class="c24StarsS c24StarsFilled"></span></span>');

                        $('.c24StarsS.c24StarsFilled', o).css(
                            'width', calcStarWidth(oComment.stars, 69),
                        );
                        $('.inl24Name', o).html(cleanString(oComment.name));
                        $('.inl24Type', o).html(oComment.type === 1 ? 'Feedback nach Abschluss' : 'Feedback nach 2 Jahren');
                        $('.inl24Date', o).html(oComment.date);
                        $('.inl24Text', o).html(cleanString(oComment.comment));
                        if (oComment.details && oComment.details.length) {
                            $('.inl24Product', o).html('Produkt : ' + cleanString(oComment.details[0].detail));
                        } else {
                            $('.inl24Product', o).html('');
                        }
                        sHtml += o.html();
                    }
                    if (sHtml) {
                        if (iStars === 0) {
                            $('.box24Bottom .inl24Header', oFeedback).text('Die neuesten Kundenbewertungen mit Kommentar');
                        } else {
                            $('.box24Bottom .inl24Header', oFeedback).text(iStars + ' Stern' + (iStars != 1 ? 'e' : '') + ' Kundenbewertungen mit Kommentar');
                        }
                        $('.box24Comments', oFeedback).html(sHtml);
                        $('.box24Comments li', oFeedback).last().addClass('c24Last');
                    }
                } else {
                    $('.box24Paginating', oFeedback).hide();
                    $('.box24Comments', oFeedback).html('<li class="inl24None">Wir konnten leider f&uuml;r Ihre Auswahl keine Kundenbewertungen mit Kommentar finden.</li>');
                }
            } else {
                $('.box24Paginating', oFeedback).hide();
                $('.box24Comments', oFeedback).html('<li class="inl24None">Wir konnten leider f&uuml;r Ihre Auswahl keine Kundenbewertungen mit Kommentar finden.</li>');
            }

        }

        function starElector() {
            const iLast = oCommentArray.length;
            const aStarredArray = [];

            for (let i = 0; i < iLast; i++) {
                if (oCommentArray[i].stars === iStars) {
                    aStarredArray.push(oCommentArray[i]);
                }
            }
            return aStarredArray;
        }

        /**
     * Cleans the String
     */
        function cleanString(string) {

            if (!string) {
                return '';
            }

            return $('<div/>').html(string.trim()).html();
        }

        /**
     * Calculate the star width
     */
        function calcStarWidth(score, width) {
            return Math.round(((score * 10) / 50) * width);
        }


        function calcPercentage(part, total, adjust) {
            if (total === 0 ) {
                return 0;
            }

            let i = Math.ceil((part / total) * 100);

            if (adjust > 0) {
                i = Math.round(i * adjust);
            }
            return i;
        }

        function calcAdjust(part, total, min) {
            let iReturn = 0;

            const i = calcPercentage(part, total,0);
            if (i < min && i !== 0) {
                iReturn = ((min - i) / i) + 1;
            }
            return iReturn;
        }

    });
})();
